import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  LedgerActivity as LedgerActivityComponent,
  LedgerActivityProps,
} from "../../components/LedgerActivity/LedgerActivity";
import { getLedgerActivityAction } from "../../actions";
import { StoreState } from "../../reducers";
import {
  getIsLoadingLedgerActivity,
  getLedgerActivity,
} from "../../reducers/loyalty/methods";
import { customerAuthenticationOccurred } from "../../utils/customer";

interface LedgerActivityContainerProps extends LedgerActivityProps {
  getLedgerActivityAction: typeof getLedgerActivityAction;
  ledgerActivity: ReturnType<typeof getLedgerActivity>;
}

class LedgerActivity extends React.Component<LedgerActivityContainerProps> {
  componentDidMount() {
    const isCustomerAuthenticated = get(
      this.props.data,
      "customer.authenticated",
      false
    );

    if (isCustomerAuthenticated) {
      this.props.getLedgerActivityAction();
    }
  }

  componentDidUpdate(prevProps: LedgerActivityContainerProps) {
    if (customerAuthenticationOccurred(prevProps.data, this.props.data)) {
      this.props.getLedgerActivityAction();
    }
  }

  render() {
    return <LedgerActivityComponent {...this.props} />;
  }
}

const mapStateToProp = (state: StoreState) => ({
  isLoading: getIsLoadingLedgerActivity(state.loyalty),
  ledgerActivity: getLedgerActivity(state.loyalty),
});

export default connect(mapStateToProp, { getLedgerActivityAction })(
  LedgerActivity
);
